<template>
  <div class="page-content" :class="[contain ? 'is-contain' : '', titlePage ? 'is-title-page' : '', noOverlay ? '' : 'overlay', fullWidth ? '' : 'set-width']">
    <slot name="page"></slot>
  </div>
</template>

<script>
export default {
  name: "PageFull",
  components: {},  
  data: () => ({}),
  mounted() {},
  beforeDestroy: function () {},
  methods: {},
  computed: {},  
  props: {
    contain:Boolean,
    titlePage:Boolean,
    noOverlay:Boolean,
    fullWidth:Boolean,
  },
};
</script>


<style lang="scss" scoped>
.is-title-page.overlay {
  .all-content {
    position: relative;
  }
  .image {
    position: absolute;
    width: 100%;
    &::after {
      position: absolute;
      top:0;
      left:0;
      width:100%;      
      background: linear-gradient(180deg, rgba(35,35,35,0) 0%, rgba(0,0,0,0.8) 100%);
      opacity: 1;
      content:" ";
    }    
  }
  .page-content {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding-bottom: 95px;
    .text-content {
      height:auto;
      flex-grow: 0;
      margin:0;
      max-width: unset;
      overflow: visible;            
    }
  }
  h1 {    
    color: #FFF;
    font-family: "Gotham Ultra";
    font-size: 4.4em;
    letter-spacing: 0;    
    text-shadow: 0 0 24px rgba(255,255,255,0.5);
    display:inline-block;
    &::after {
      content:" ";
      margin-top:10px;
      height: 2px;
      width:100%;
      background: linear-gradient(270deg, rgba(245,131,31,0) 0%, #F5831F 24.44%, #FFD62F 50.45%, #F5831F 100%), linear-gradient(270.05deg, rgba(255,255,255,0) 0%, #FFFFFF 49.41%, rgba(255,255,255,0) 100%);
      display: block;
    }
  }
}
.page-content {
    width:100%;
    height:calc(100% - 50px);      
    margin:0;
    padding:0;
}
.all-content {
    display:flex;    
    height:100vh;
    width:100%;      
}
.overlay .image {
  &:after {
    content:" ";
    position:absolute;
    left:0;
    top:0;
    width:100%;
    height:100%;
    background-image:url('~@/assets/shapes/side-graphic.svg');
    background-size: contain;
    background-position: left;
    background-repeat: no-repeat;
    opacity: 0.05;
  }
}
.image {
    width:calc(100% - 180px);
    height:calc(100% - 50px);
    flex-shrink: 0;
    flex-grow: 1;
    position:absolute;
    top:0;
    right:0;     
}

.text-content {
    position:relative;    
    overflow: auto;
    margin-bottom: 50px;
    max-height: calc(100% - 145px);    
    &.center {
      text-align: center;
      max-width: 470px;
      margin:0 auto;
      padding-right: 0;
      top:50%;
      transform: translateY(-50%);
      position: relative;
    }    
    &::-webkit-scrollbar {
        width: 5px;
    }
    &::-webkit-scrollbar-track {
        background-color: #2E2E30;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #B2B3B8;
    }
    p {
      max-width: 550px;    
    }    
}
.set-width .text-content{
  width:85%;    
  padding-right: 50px;
  max-width: 985px;    
}
.content {    
    padding:65px;
    box-sizing: border-box;
}
.image img {
    position: absolute;
    left:0;
    top:0;    
    height:100%;
    width:100%;
    object-fit: cover;
}
.is-contain .image img {
  object-fit: contain;
  object-position: right;
}
@media (max-width:699px) {
  .page-content {
    text-align: center;    
    
    
    .text-content {
      width: auto;
      padding-right: 0;      
    }
    &.is-title-page h1{
      font-size: 3em;
    }
  }
}
</style>
